import React from 'react';
import { Link } from 'react-router-dom';
// import Button from 'shared/components/button/Button';

class ClientSideHead extends React.Component {
  render() {
    return (
      <section className="client-header">
        <h3>{this.props.label}</h3>
        <Link to={this.props.url} className="btn btn-primary">
          {this.props.btnTxt}
        </Link>
      </section>
    );
  }
}

export default ClientSideHead;
